const html1 = `
&lt;!DOCTYPE html>
&lt;html>
    &lt;head>&lt;/head>
    &lt;body>&lt;/body>
&lt;/html>
 `
const html2 = `
&lt;html lang="zh">
    ...
&lt;/html>
 `
const html3 = `
&lt;head>
    &lt;meta http-equiv="X-UA-Compatible" content="IE=edge">
&lt;/head>
 `
const html4 = `
&lt;head>
    &lt;meta charset="UTF-8">
&lt;/head>
 `
const html5 = `
&lt;link rel="stylesheet" href="/static/css/index.css">
                
&lt;script src="static/js/index.js">&lt;/script>
 `
const html6 = `
&lt;head>
    &lt;meta name="viewport" content="width=device-width,initial-scale=1.0">
&lt;/head>
 `
const html7 = `
&lt;input type="text" disabled>

&lt;input type="checkbox" value="1" checked>

&lt;select>
    &lt;option value="1" selected>1&lt;/option>
&lt;/select>
 `
const html8 = `
&lt;!-- 不建议 -->
&lt;span class="avatar">
    &lt;img src="...">
&lt;/span>

&lt;!-- 建议 -->
&lt;img class="avatar" src="...">
 `

export default {
    html1,
    html2,
    html3,
    html4,
    html5,
    html6,
    html7,
    html8
}